module.exports = __webpack_public_path__ + "static/img/goods-666.d076954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-666.png
// module id = UWju
// module chunks = 2